import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { MarcacaoDTO } from '../../../dtos/marcacao-dto';

@Component({
  selector: 'app-atendimento-procedimento-detail',
  templateUrl: './atendimento-procedimento-detail.component.html',
  styleUrls: ['./atendimento-procedimento-detail.component.css']
})
export class AtendimentoProcedimentoDetailComponent implements OnInit {

  marcacaoDTO: MarcacaoDTO;

  formularioInformacaoMarcacao: FormGroup;

  visualizarTitular: boolean = false;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.marcacaoDTO = Object.assign(new MarcacaoDTO(), history.state.marcacaoDTO);

    this.formularioInformacaoMarcacao = this.formBuilder.group({
      nomePacienteTitular: '',
      cpfTitular: '',
      dataNascimento: '',
      foneResidencial: '',
      foneCelular: '',
      nomeMedico: '',
      loginUserMarcacao: '',
      dilataPupila: '',
    });
  }

  ngOnInit() {

    this.configurarForm();
  }

  gotoList() {
    const paginaAnterior = history.state.paginaAnterior;

    this.router.navigate(['/' + paginaAnterior], {
      state: {
        filtroMarcacao: history.state.filtroMarcacao,
        textFilter: history.state.textFilter,
      }
    });
  }

  configurarForm(): void {

    this.configurarCampos();

    this.formularioInformacaoMarcacao.disable();
  }

  get formControl() {
    return this.formularioInformacaoMarcacao.controls;
  }

  configurarCampos(): void {

    this.formControl.nomeMedico.setValue(this.marcacaoDTO.nomeMedico);
    this.formControl.dataNascimento.setValue(this.marcacaoDTO.dataNascimento);
    this.formControl.loginUserMarcacao.setValue(this.marcacaoDTO.loginUserMarcacao);

    this.visualizarTitular = (this.marcacaoDTO.cpfTitular !== null &&
      this.marcacaoDTO.cpfTitular !== undefined &&
      this.marcacaoDTO.cpfTitular !== '');

    if (!this.visualizarTitular) {
      this.formControl.foneResidencial.setValue(this.marcacaoDTO.foneResidencial);
      this.formControl.foneCelular.setValue(this.marcacaoDTO.foneCelular);
    } else {
      this.formControl.foneResidencial.setValue(this.marcacaoDTO.foneResidencialTitular);
      this.formControl.foneCelular.patchValue(this.marcacaoDTO.foneCelularTitular);
      this.formControl.nomePacienteTitular.setValue(this.marcacaoDTO.nomePacienteTitular);
      if (!this.marcacaoDTO.cpfTitular) {
        this.marcacaoDTO.cpfTitular = '';
      }
      this.formControl.cpfTitular.patchValue(cpf.format(this.marcacaoDTO.cpfTitular));
    }

    this.formControl.dilataPupila.setValue(this.marcacaoDTO.dilataPupilaFormatado);

    this.cd.detectChanges();
  }

}
